// Module imports (bundled by Vite)
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Toast from 'bootstrap/js/dist/toast';
import Tooltip from 'bootstrap/js/dist/tooltip';
import ePub from "epubjs";
import {EpubCFI} from "epubjs";
import JSZip from "jszip";
import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar, Keyboard, Zoom, Autoplay } from 'swiper/modules';
import Helpers from './common/Helpers.js';

// Swiper modules config
Swiper.use([Navigation, Pagination, Scrollbar, Keyboard, Zoom, Autoplay]);

// Required for using swiper on html page
window.Swiper = Swiper;

// Required for using jszip on html page
window.JSZip = JSZip;

// Required for using epubjs on html page
window.ePub = ePub;
window.EpubCFI = EpubCFI;

// Utility function
window.debounce = (f, wait, immediate) => {
	let timeout
	return (...args) => {
		const later = () => {
			timeout = null
			if (!immediate) f(...args)
		}
		const callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) f(...args)
	}
};

// Dynamic link functions
window.searchString = window.location.search;
window.urlSearchParams = new URLSearchParams(searchString);
window.searchParams = Object.fromEntries(urlSearchParams.entries());
window.linkItems = document.getElementsByClassName('aby-link')
window.paginationLinks = document.getElementsByClassName('page-link')

window.setDynamicLinks = function(items, excluded_words) {
	Array.from(items).forEach(link => {
		let hrefData = link.getAttribute('aby-data-href');
		let hrefString = hrefData
		if (!hrefData.includes('?')) {
			hrefString += '?';
		}

		for (const [key, value] of Object.entries(searchParams)) {
			if (!excluded_words.includes(key) && !hrefString.includes(key)) {
				if (hrefString.endsWith('?')) {
					hrefString += key + '=' + value;
				} else {
					hrefString += '&' + key + '=' + value;
				}
			}
		}

		link.setAttribute('href', hrefString);
	})

}

// MAIN MENU

const mainNavbar = document.querySelector('.main-navbar');

// Menu ativo ao rolar a pagina
window.onscroll = function () {
	if (window.scrollY > window.innerHeight) mainNavbar.classList.add('active');
	else mainNavbar.classList.remove('active');
}

// var comicreader = new Swiper('.comic-reader-container', {
// 	navigation: {
// 		nextEl: '.swiper-button-next',
// 		prevEl: '.swiper-button-prev',
// 	},
//
// 	allowTouchMove: true,
// 	zoom: {
// 		maxRatio: 2,
// 	},
// })

var webdoor = new Swiper('.section-home-webdoor', {
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	loop: true,
	pagination: {
		clickable: true,
		el: '.swiper-pagination',
	},
	preventInteractionOnTransition: true, // ← adicionado
	speed: 1000,
	slidesPerView: 1,
	watchOverflow: true,
});

var coversSlider = new Swiper('.covers-slider', {
	centeredSlides: true,
	grabCursor: true,
	touchStartPreventDefault: false, // ← evita scroll para o topo no mobile
	touchAngle: 45, // ← tolerância maior a toques diagonais
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.outside-pagination',
		clickable: true,
		type: 'custom',
		renderCustom: function (swiper, current, total) {
			let customPaginationHtml = "";
			for (let i = 0; i < total; i++) {
				if (i == (current - 1)) {
					customPaginationHtml += '<span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span>';
				} else {
					customPaginationHtml += '<span class="swiper-pagination-bullet"></span>';
				}
			}
			return customPaginationHtml;
		}
	},
	slidesPerView: 'auto',
	spaceBetween: 16,
	watchOverflow: true,
	breakpoints: {
		576: {
			centeredSlides: false,
		}
	}
});

// SEARCH

$('#btn-search').fancybox({
	baseClass: 'search-modal',
	afterClose: function () {
		$('.search-form')[0].reset();
	}
});

// LINK TO READER TOOLTIP 

var tooltipTriggerList = [].slice.call(document.querySelectorAll('.link-to-reader'));

var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl, {
		'delay': {
			'show': 300,
			'hide': 0
		}
	});
});


// STORY CARD COLLAPSE

const storyCardList = [].slice.call(document.querySelectorAll('.story-card-body'));
const storyCardCollapseList = storyCardList.map(function (collapseEl) {
	const targetId = collapseEl.id;
	const trigger = document.querySelector(`a[href="#${targetId}"]`);

	// Toggle icon
	const icon = trigger.children[0],
		openIcon = icon.querySelector('[name*="add"]'),
		closeIcon = icon.querySelector('[name*="remove"]');

	Helpers.toggleCollapseIcon(collapseEl, openIcon, closeIcon);
});